// SEI Standard Tracking Requirements
//
// .../wiki/spaces/SL/pages/10059778/SEI+Standard+Tracking+Requirements

import $ from 'jquery'
import { kebabCase, uniqueId } from 'lodash'

SOPHIA.standardTracking = function ($mainContainer) {
  $('select', $mainContainer).each((i, el) => {
    var $select = $(el),
        selectLabel = kebabCase($select.attr('id'));

    addTrackingData($select, 'dropdown', selectLabel);
  });

  $('input:text', $mainContainer).each((i, el) => {
    var $inputText = $(el),
        inputLabel = kebabCase($inputText.attr('id'));

    addTrackingData($inputText, 'input-text', inputLabel);
  })

  $('input:submit', $mainContainer).each((i, el) => {
    var $button = $(el),
        buttonLabel = kebabCase($button.val()) + '-' + uniqueId();

    addTrackingData($button, 'submit', buttonLabel);
  });

  $('input:radio', $mainContainer).each((i, el) => {
    var $radio = $(el),
        radioLabel = kebabCase($radio.attr('id'));

    addTrackingData($radio, 'radio-button', radioLabel);
  });

  $('button:submit', $mainContainer).each((i, el) => {
    var $button = $(el),
        trimButtonText = $.trim($button.text()),
        buttonLabel;

    if (trimButtonText.length > 0) {
      buttonLabel = kebabCase($button.text()) + '-' + uniqueId();
    } else { // in case of image of empty tag
      buttonLabel = 'button-' + uniqueId();
    }

    addTrackingData($button, 'submit', buttonLabel);
  });

  $('a[class*="button"], .pay-button', $mainContainer).each((i, el) => {
    var $button = $(el),
        buttonLabel = kebabCase($button.text()) + '-' + uniqueId();

    addTrackingData($button, 'button', buttonLabel);
  })

  $('a:not([class*="button"]', $mainContainer).each((i, el) => {
    var $link = $(el),
        trimLinkText = $.trim($link.text()),
        linkLabel,
        linkType;

    if (trimLinkText.length > 0) {
      linkLabel = kebabCase($link.text()) + '-' + uniqueId();
    } else { // in case of image of empty tag
      linkLabel = 'link-' + uniqueId();
    }

    if ($link.parents().hasClass('w-flexible-footer')) {
      linkType = 'footer-link';
    } else if ($link.parents().hasClass('w-flexible-header__actions-menu')) {
      linkType = 'nav-link';
    } else {
      linkType = 'link';
    }

    addTrackingData($link, linkType, linkLabel);
  })
}

function addTrackingData(el, type, value) {
  $(el).attr('data-km-type', type).attr('data-km-value', value)
}

$(document).ready(() => {
  SOPHIA.standardTracking($('body.flexible-layout'));
})
